import { createSelector } from 'reselect';

import { getCoworkingOperator } from './getCoworkingOperator';

export const coworkingOperatorCompanyNameSelector = createSelector(
  getCoworkingOperator,
  operator => operator?.companyName ?? '',
);
